import GAuth from "vue-google-oauth2";

const gauthOption = {
  clientId: "253452170434-mna9l658pf8qu3mq0bhqomf6c1lok5pj.apps.googleusercontent.com",
  scope: "email openid",
  prompt: "select_account"
};

export default ({ Vue }) => Vue.use(GAuth, gauthOption);
